<template>
	<div>
		<buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" ref="SetBtn"></buttonlist>
		<div id="xpane-0">
			<vxe-table
				:data="dataSet"
				v-loading="loading"
				:highlight-current-row="true"
				show-overflow-tooltip="true"
				border
				stripe
				resizable
				show-overflow="tooltip"
				:height="tableHeight"
				header-row-class-name="headerclass"
				size="mini"
				style="width: 100%; margin-top:0px"
				ref="singleTable"
		>
			<vxe-table-column type="selection" v-if="false"></vxe-table-column>
			<vxe-table-column show-footer-overflow field="suggest_type" :title="$t('getapi[7183]')" width="150"></vxe-table-column>
			<vxe-table-column show-footer-overflow field="suggest_type_name" :title="$t('getapi[7184]')" width="150"></vxe-table-column>
			<vxe-table-column show-footer-overflow field="partcode" :title="$t('getapi[112]')" width="150"></vxe-table-column>
			<vxe-table-column show-footer-overflow field="partversion" :title="$t('getapi[149]')" width="150"></vxe-table-column>
			<vxe-table-column field="original_date" :title="$t('getapi[7185]')" width="150">
				<template slot-scope="scope">
					{{scope.row.original_date | toDate}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="suggest_qty" :title="$t('getapi[3101]')" align="right" width="80">
				<template slot-scope="scope">
					{{scope.row.suggest_qty | thousandth}}
				</template>
			</vxe-table-column>
			<vxe-table-column field="suggest_date" :title="$t('getapi[7186]')" width="150">
				<template slot-scope="scope">
					{{scope.row.suggest_date | toDate}}
				</template>
			</vxe-table-column>
			<vxe-table-column show-footer-overflow field="order_no" :title="$t('getapi[4529]')" width="150"></vxe-table-column>
			<vxe-table-column show-footer-overflow field="line_no" :title="$t('getapi[1425]')" align="right" width="80"></vxe-table-column>
			<vxe-table-column show-footer-overflow field="item_code" :title="$t('getapi[6211]')" width="150"></vxe-table-column>
			<vxe-table-column show-footer-overflow field="products" :title="$t('getapi[145]')" width="150"></vxe-table-column>
			<vxe-table-column show-footer-overflow field="part_spec" :title="$t('getapi[125]')" width="150"></vxe-table-column>
		</vxe-table>
		</div>
			<!--<el-row>
				<el-col :span="18">
					<el-pagination
						style="margin-top: 1em"
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="100"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 60px;color: #545c64;font-size: 95%;">表名/视图名称:{{ DbTbNames }}</div>
				</el-col>
			</el-row>-->
		<span style="margin-top: 3px" v-if="dataDetail!=''">{{$t('getapi[7187]')}}{{dataDetail.statusinfo}}{{$t('getapi[7188]')}}{{dataDetail.statusstatistic}}{{dataDetail.statuscur}}</span>
		<!-- </el-tabs> -->
		<serce :isVisible="isVisible" queryData="MPSSuggest" ref="ser" @getser="serclick"></serce>
		<!-- 改变表格顺序 -->
		<ctable :isVisible="false" :title="$t('getapi[7189]')" queryData="MPSSuggest" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>
	
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'2_mainsuggestview',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3,
                maxHeight: this.$windowSize.tableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: 100, // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			tableHeader: [],
			dataDetail:'',
            scrollTop:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                setTimeout(() => {
                    that.$processdata.initForm(0)
                }, 500);
            })
        },
    },
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6603]"),'MRP');
        },
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			//只读权
			// if (that.$limits.ReadOnlyRightsView('plv2', 83, 1, that.total)) {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
				} else {
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
				}
			// }
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'MPSSuggest');
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac
			};
			that.$http.urlpost('/MRP/CountView/GetMainMRPSuggestView', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
                    that.$http.urlpost('/MRP/Tool/GetMRPStatus', '', function (res) {
                        if (res.Success == 1) {
                            that.dataDetail = res.DataContent
                        }
                    });
				} else {
					that.$message.error(res.Msg);
				}
				that.authority();
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndexs,
				Ids: '',
				Param: datac
			};
			that.$http.urlpost('/MRP/CountView/GetMainMRPSuggestViewToExecl', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
				that.loading = false;
			});
		},
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
